import React, { useState } from "react";
import { connect } from "react-redux";
import * as interviewActions from "../../../actions/interviewActions";
import * as contractService from "../../../services/contractService";
import * as formsService from "../../../services/formsService";
import { Field } from "formik";
import { PhoneInputField } from "@coverme/forms";
import { Formik } from "formik";
import OnSubmitValidationError from "../../../components/FormComponents/OnSubmitValidationError";
import { YesNoButtons } from "../../../components/FormComponents/YesNoButtons";
import { WizardButtonsField } from "../Components/WizardButtons";
import { validationSchema } from "./validationSchema";
import { CTA } from "@coverme/forms";
import { ConfirmationModal } from "../../../components/ConfirmationModal/ConfirmationModal";
import { toast } from "react-toastify";
import { func } from "prop-types";

const InterviewContractConsent = ({
    onError,
    onSubmit,
    onUpdateContractConsent,
    patientFullName,
    personId,
    contractConsent,
    sendContractByText,
    navigateToNextPage,
    navigateToPreviousPage,
}) => {
    const [shouldShowTextSentConfirmationModal, setShouldShowTextSentConfirmationModal] = useState(false);

    const onConfirmTextSentModal = () => {
        sendContractByTextAndShowMessage(contractConsent.mobilePhoneNumber);
        setShouldShowTextSentConfirmationModal(false);
    };

    const modalText = () => {
        return "A text message has already been sent to the patient. Do you want to re send it?";
    };

    function onFormSubmit(formData) {
        return onSubmit(formData).then(result => {
            navigateToNextPage();
        });
    }

    function onSendContractByTextClick(mobilePhoneNumber) {
        if (contractConsent?.hasContractBeenSentByText) {
            setShouldShowTextSentConfirmationModal(true);
        } else {
            sendContractByTextAndShowMessage(mobilePhoneNumber);
            // just in case
            setShouldShowTextSentConfirmationModal(false);
        }
    }

    function onDownloadContract() {
        contractService.downloadContract();
    }

    function updateHasPhoneAvailable(isAvailable) {
        const toBeUpdated = {
            hasMobilePhoneAvailable: isAvailable,
            ...contractConsent,
        };
        onUpdateContractConsent(toBeUpdated);
    }

    function sendContractByTextAndShowMessage(mobilePhoneNumber) {
        sendContractByText(contractConsent, personId, mobilePhoneNumber);
        toast.success("A text message has been sent to the phone number. The interview may proceed.");
    }

    const initialValues = contractConsent;
    const thePatient = patientFullName || "the patient";
    return (
        <div className="wizard-page">
            <h2 className="title">Contract Consent</h2>
            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                onSubmit={onFormSubmit}
                validationSchema={validationSchema}
                render={props => {
                    const { setFieldValue, setFieldTouched, resetForm, handleSubmit, errors, touched, values } = props;
                    const getValidationState = formsService.getValidationState.bind(this, errors, touched);
                    const isRequired = formsService.isRequired.bind(this, validationSchema, values);
                    const getErrors = formsService.getErrors.bind(this, errors);
                    return (
                        <form className="wizard-form">
                            <OnSubmitValidationError callback={onError} />
                            <div className="form-section">
                                <div className="form-control auto-input">
                                    <YesNoButtons
                                        name={"hasMobilePhoneAvailable"}
                                        title={`Does ${thePatient} has a mobile phone available to sign a contract?`}
                                        isRequired={isRequired}
                                        getErrors={getErrors}
                                        getValidationState={getValidationState}
                                        onFieldChange={isSelected => {
                                            updateHasPhoneAvailable(isSelected);
                                        }}
                                        {...props}
                                    />
                                </div>
                                {values.hasMobilePhoneAvailable === true && (
                                    <div className="form-section">
                                        <div className="form-control xxl-input">
                                            <Field
                                                name="mobilePhoneNumber"
                                                render={({ field }) => (
                                                    <PhoneInputField
                                                        {...field}
                                                        title={"Mobile Phone Number"}
                                                        id="mobilePhoneNumber"
                                                        value={field.value}
                                                        errorMessage={getErrors(field)}
                                                        required={isRequired(field)}
                                                        validState={getValidationState(field)}
                                                        changeEvent={e => {
                                                            setFieldValue("mobilePhoneNumber", e);
                                                        }}
                                                    />
                                                )}
                                            />
                                            <div className="form-control m-input">
                                                <CTA
                                                    styleType="cta cta--grey-dark cta--large"
                                                    click={() => {
                                                        onSendContractByTextClick(values.mobilePhoneNumber);
                                                    }}
                                                >
                                                    Send Contract via Text
                                                </CTA>
                                            </div>
                                            <ConfirmationModal
                                                isShown={shouldShowTextSentConfirmationModal}
                                                onClose={() => {
                                                    setShouldShowTextSentConfirmationModal(false);
                                                }}
                                                onConfirm={() => {
                                                    onConfirmTextSentModal();
                                                    setShouldShowTextSentConfirmationModal(false);
                                                }}
                                                body={modalText()}
                                            />
                                        </div>
                                    </div>
                                )}
                                {values.hasMobilePhoneAvailable === false && (
                                    <>
                                        <div className="form-control auto-input">
                                            <p>Please, download and Print the contract to the Patient</p>
                                            <div className="form-control m-input">
                                                <CTA
                                                    styleType="cta cta--grey-dark cta--large"
                                                    click={onDownloadContract}
                                                >
                                                    Download
                                                </CTA>
                                            </div>
                                        </div>
                                        <div className="form-control auto-input">
                                            <YesNoButtons
                                                name={"hasContractBeenPrinted"}
                                                title={`Has the contract being printed and given to ${thePatient}?`}
                                                isRequired={isRequired}
                                                getErrors={getErrors}
                                                getValidationState={getValidationState}
                                                onFieldChange={isSelected => {
                                                    onUpdateContractConsent({
                                                        ...contractConsent,
                                                        hasContractBeenPrinted: isSelected,
                                                    });
                                                }}
                                                {...props}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>

                            <WizardButtonsField
                                isFirstPage={false}
                                navigateToNextPage={onFormSubmit}
                                navigateToPreviousPage={navigateToPreviousPage}
                            />

                            <div className="required_field_indicator_explained">Indicates required field</div>
                        </form>
                    );
                }}
            />
        </div>
    );
};

export const InterviewContractConsentContainer = connect(
    ({ interview, person }) => ({
        contractConsent: contractService.getEffectiveContractConsent(interview),
        patientFullName: interview.entry.patient.fullName,
        personId: person.isInitialized && contractService.getContractSignerPersonId(interview, person),
    }),
    dispatch => ({
        onUpdateContractConsent: data => dispatch(interviewActions.updateContractConsent(data)),
        onSubmit: data => dispatch(interviewActions.setContractConsent(data)),
        onError: () => dispatch(interviewActions.setInterviewError("contractConsent")),
        sendContractByText: (contractConsent, personId, mobilePhoneNumber) =>
            dispatch(interviewActions.sendContractByText(contractConsent, personId, mobilePhoneNumber)),
    })
)(InterviewContractConsent);
